import profileApi from '@/api/vo/profile';

const defaultState = () => ({
	myProfile: {},
	myBank: {},
	mitraData: null,
	responSukses: {},
	errorValidation: []
});

const state = defaultState();

const getters = {

};

const mutations = {

	setProfile(state, data) {
		state.myProfile = data.data;
	},
	setBank(state, data) {
		state.myBank = data.data;
	},
	setMitraData(state, data) {
		state.mitraData = data.data;
	},
	setErrorValidation(state, data) {
		state.errorValidation = data
	},
	clearDataUser(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {

	getProfile({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getProfile(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProfile', data.results);
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data mitra tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},

	getProfileMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getProfileMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProfile', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data mitra tidak dapat ditampilkan.'
				}, { root: true });
				commit('setProfile', { data: {} });
				reject()
			});
		});
	},

	getProfilePramitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getProfilePramitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setProfile', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data mitra tidak dapat ditampilkan.'
				}, { root: true });
				commit('setProfile', { data: {} });
				reject()
			});
		});
	},

	editProfileMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.editProfileMitra(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					const authData = data.results.data
					let token = authData.token
					let memberData = authData.data_member
					memberData['token'] = token
					commit('auth/success', memberData , { root: true });
					dispatch('success', data)
					resolve()
				} else {
					dispatch('errorHandler', data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan data mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	editProfilePramitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.editProfilePramitra(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					const authData = data.results.data
					let token = authData.token
					let memberData = authData.data_member
					memberData['token'] = token
					commit('auth/success', memberData , { root: true });
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan data mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	changeImageMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.changeImageMitra(value).then( res => {
				const data = res.data;
				const image = data.results.data.image_profile_url;
				if ( data.status == 200 ) {
					commit('auth/updateImage', image , { root: true });
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan gambar profil mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},
	changeImagePramitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.changeImagePramitra(value).then( res => {
				const data = res.data;
				const image = data.results.data.image_profile_url;
				if ( data.status == 200 ) {
					commit('auth/updateImage', image , { root: true });
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan gambar profil mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	changePasswordMitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.changePasswordMitra(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					resolve()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan password akun mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	changePasswordPramitra({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.changePasswordPramitra(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan password akun mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	editBank({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			profileApi.editBank(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					resolve()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Perubahan data bank mitra tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	getBankMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getBankMitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setBank', data.results);
					resolve(data)
				} else {
					resolve(data)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setBank', []);
				reject()
			});
		});
	},

	getBankPramitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getBankPramitra(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setBank', data.results);
					resolve(data)
				} else {
					resolve(data)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setBank', []);
				reject()
			});
		});
	},

	async getMitraData({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			profileApi.getMitraData(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMitraData', data.results);
					resolve(data)
				} else {
					resolve(data)
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMitraData', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};